module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_cat03-4507a6e3f8967aa73099565168c90a66.svg";